import { render } from "./EditSocketConfigModal.vue?vue&type=template&id=01c2b48c&scoped=true"
import script from "./EditSocketConfigModal.vue?vue&type=script&lang=js"
export * from "./EditSocketConfigModal.vue?vue&type=script&lang=js"

import "./EditSocketConfigModal.vue?vue&type=style&index=0&id=01c2b48c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-01c2b48c"]])

export default __exports__